import {Box, Col, Row} from 'components/Grid';
import {EventPlace} from 'modules/events/components/EventPlace';
import {FC} from 'react';
import {EventXDescription} from 'modules/events/components/EventXDescription';
import style from './style.module.scss';
import {useRouter} from 'next/router';
import {useGetEventQuery} from 'modules/events/services';

export const EventInfo: FC = () => {
    const {query} = useRouter();
    const {data} = useGetEventQuery({id: query.slug as string});
    const event = data?.data;
    const {previewDescription} = event || {};

    return (
        <div className={previewDescription ? style.withDescription : ''}>
            <Box>
                <Row>
                    <Col className={style.place} lg={4} md={12} sm={12}>
                        <EventPlace />
                    </Col>
                    {previewDescription && (
                        <Col lg={8} md={12} sm={12}>
                            <EventXDescription />
                        </Col>
                    )}
                </Row>
            </Box>
        </div>
    );
};
